/** @module Classes */ /** typedoc */
/**
 * @class Asset
 * @summary Define the Library Asset used for all Falcor Library Routes
 */
class LibraryAsset {
    constructor() {
        this.creationDate = null;
        this.creationState = null;
        this.duration = null;
        this.fileSize = null;
        this.id = null;
        this.isAlreadyReleased = null;
        this.isAtLeastCdAudioQuality = null;
        this.hasArtwork = false;
        this.hasAutomaticMastering = false;
        this.hasOneMasterFailed = null;
        this.hasOneMasterInProgress = null;
        this.hasPreview = null;
        this.modificationDate = null;
        this.name = null;
        this.originalFormat = null;
        this.ownerId = null;
        this.permissions = null;
        // Project is not in core.models yet
        this.project = null;
        this.read = null;
        this.sharesCount = 0;
        this.soundCloudMasterState = null;
        this.transferred = null;
        this.versionsCount = null;
        this.trackType = null;
        this.collaboratorsCount = null;
        this.countOfFiles = 1;
    }
}

export { LibraryAsset };
